import i18next from 'i18next';
import { fetchUserInfos } from '../actions/account/user';
export const langs = ['fr', 'en'];
export const langsDisplay = {
    fr: 'Français',
    en: 'English',
};
export const getLanguageCode = () => i18next.language.split('-')[0];
export const getCurrentLanguage = () => {
    return langsDisplay[getLanguageCode()];
};
export const getPhraseOrEmptyString = (key) => {
    return i18next.exists(key) ? i18next.t(key) : '';
};
i18next.on('languageChanged', (lng) => {
    if (window.store) {
        const { scribeSession: { currentPlatform }, account: { session: { isLoggedin }, }, } = window.store.getState();
        if (currentPlatform === 'account' && isLoggedin) {
            // if we are in dashboard we fetch user infos for new licence information
            window.store.dispatch(fetchUserInfos.request());
        }
    }
});
export const getPhraseBoldData = (phrase, separator) => {
    const phrases = phrase.split(separator);
    return phrases.map((phrase, index) => ({ text: phrase, isBold: index % 2 === 1 })).filter((p) => p.text);
};
